import {ColorContextualItem} from "./ColorContextualItem";
import {TextContextualItem} from "./TextContextualItem";
import {contextualMenuTypes} from "../../../helpers/treeContextualMenu.helper";

export const contextualItemComponents = {
    [contextualMenuTypes.TEXT]: TextContextualItem,
    [contextualMenuTypes.COLOR]: ColorContextualItem,
};
